import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button, Form, Spinner } from "react-bootstrap";
import styles from "./AsnPage.module.css";
import { Formik } from "formik";
import { InfoCircleFill } from "react-bootstrap-icons";
import "moment/locale/id";
import ReactSelectForm from "../../components/ReactSelectForm/ReactSelectForm";
import { getValueFromOptions } from "../../utils/ReactSelectHelper";
import { DatePicker } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import * as apiAsn from "../../apis/asn.js";
import { toast } from "react-toastify";
const INPUT_REQUIRED = "*Wajib diisi";

const customStyleError = {
  control: (base) => ({
    ...base,
    border: "1px solid red",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid red",
    },
  }),
};

const onChangeAsnQty = (e, { setFieldValue, values, index }) => {
  const items = values.items;
  items[index].asnQuantity = e.target.value;
  items[index].isInvalid = false;
  setFieldValue("items", items);
};

const onChangeAsnCustomQty = (e, { setFieldValue, values, index }) => {
  const items = values.items;
  items[index].asnCustomQuantity = e.target.value;
  items[index].isInvalidCustom = false;
  setFieldValue("items", items);
};

const AsnInputForm = (props) => {
  const {
    visible,
    purchaseOrder,
    isLoading,
    displayAlert,
    setIsLoading,
    deliveryOptions,
  } = props;

  const asn = purchaseOrder?.asn ?? {};
  const hasAsn = !!purchaseOrder?.asn;

  const navigate = useNavigate();

  const navigateToPdf = (id) => navigate(`/asn/pdf/${id}`);
  const onSubmitForm = async (values, { setFieldValue }) => {
    setIsLoading(true);

    const { items, deliveryMethod, expectedTimeArrival } = values;
    let isSubmitValid = true;
    const newitems = items.map((item) => {
      if (
        !item.asnQuantity ||
        (!!item.customQuantity && !item.asnCustomQuantity)
      ) {
        if (isSubmitValid) isSubmitValid = false;
        return {
          ...item,
          isInvalid: !item.asnQuantity,
          isInvalidCustom: !item.asnCustomQuantity,
        };
      }
      return {
        ...item,
      };
    });

    if (!deliveryMethod || !expectedTimeArrival) isSubmitValid = false;

    if (!isSubmitValid) {
      setFieldValue("items", newitems);
      setIsLoading(false);
      toast.info("Tolong lengkapi bagian yang harus diisi");
      return;
    }

    try {
      const { data } = await apiAsn.createAsn({
        data: {
          ...values,
          purchaseOrderId: purchaseOrder.id,
        },
      });
      toast.success("Sukses menyimpan data ASN");
      navigateToPdf(data.data);
    } catch (error) {
      displayAlert({ type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {visible && (
        <section className="asn-input-form mt-4">
          <Row className={styles.confirmationCard}>
            <h5 className="mb-4 mx-auto">
              Input Data Advanced Shipping Notice
            </h5>
            <InfoMessage />
            <Formik
              initialValues={{
                deliveryMethod: asn?.deliveryMethod ?? null,
                items: purchaseOrder?.purchaseOrderItem ?? [],
                expectedTimeArrival: !!asn?.expectedTimeArrival
                  ? moment(asn?.expectedTimeArrival)
                  : null,
              }}
              enableReinitialize={true}
              onSubmit={onSubmitForm}
            >
              {({ setFieldValue, values, handleSubmit, touched }) => (
                <Form onSubmit={handleSubmit}>
                  <Col className="w-50 my-2">
                    <DeliveryMethod
                      values={values}
                      setFieldValue={setFieldValue}
                      isError={!values.deliveryMethod && touched.deliveryMethod}
                      isLoading={isLoading}
                      hasAsn={hasAsn}
                      deliveryOptions={deliveryOptions}
                    />
                  </Col>
                  <Col className="w-50 mb-4">
                    <EstimatedTimeArrival
                      values={values}
                      setFieldValue={setFieldValue}
                      isError={
                        !values.expectedTimeArrival &&
                        touched.expectedTimeArrival
                      }
                      isLoading={isLoading}
                      hasAsn={hasAsn}
                    />
                  </Col>
                  <Col>
                    <Table bordered responsive className={styles.tableBody}>
                      <thead className={styles.tableHeader}>
                        <TableHeader />
                      </thead>
                      <tbody>
                        {values.items.map((item, index) => (
                          <TableBody
                            key={index}
                            index={index}
                            item={item}
                            setFieldValue={setFieldValue}
                            values={values}
                            hasAsn={hasAsn}
                          />
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                  <Col className="float-end">
                    {hasAsn ? (
                      <Button
                        type="button"
                        className={styles.btnGreen}
                        disabled={isLoading}
                        onClick={() => navigateToPdf(purchaseOrder?.asn?.id)}
                      >
                        {isLoading && <Spinner animation="border" size="sm" />}
                        Download PDF
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        className={styles.btnGreen}
                        disabled={isLoading}
                      >
                        {isLoading && <Spinner animation="border" size="sm" />}
                        Simpan
                      </Button>
                    )}
                  </Col>
                </Form>
              )}
            </Formik>
          </Row>
        </section>
      )}
    </>
  );
};

const TableHeader = () => {
  return (
    <tr className="text-center">
      <th>No</th>
      <th>ID</th>
      <th width={400}>Nama Barang</th>
      <th>PO Qty</th>
      <th width={200}>PO Unit</th>
      <th>Qty Pengiriman</th>
    </tr>
  );
};

const TableBody = ({ index, item, setFieldValue, values, hasAsn }) => {
  const rowSpan = !!item.customQuantity ? 2 : 1;
  return (
    <>
      <tr key={index + 1} >
        <td className="text-center align-middle" rowSpan={rowSpan}>{index + 1}</td>
        <td className="text-center align-middle" rowSpan={rowSpan}>{item.sku}</td>
        <td className="text-center align-middle" rowSpan={rowSpan}>{item.name}</td>
        <td className="text-center align-middle">{rowSpan == 2 ? item.customQuantity : item.quantity}</td>
        <td className="text-center align-middle">{rowSpan == 2 ? item.customPurchasingUnit : item.unit}</td>
        <td>
          <InputForm
            isCustom={rowSpan == 2}
            item={item}
            hasAsn={hasAsn}
            setFieldValue={setFieldValue}
            values={values}
            index={index}
          />
        </td>
      </tr>
      {rowSpan == 2 && (
        <SecondRow
          item={item}
          hasAsn={hasAsn}
          setFieldValue={setFieldValue}
          values={values}
          index={index}
        />
      )}
    </>
  );
};

const SecondRow = ({ item, hasAsn, setFieldValue, values, index }) => {
  return (
    <tr>
      <td className="text-center align-middle">{item.quantity}</td>
      <td className="text-center align-middle">{item.unit}</td>
      <td>
        <InputForm
          isCustom={false}
          item={item}
          hasAsn={hasAsn}
          setFieldValue={setFieldValue}
          values={values}
          index={index}
        />
      </td>
    </tr>
  );
};

const InfoMessage = () => {
  return (
    <div className={styles.infoMessageContainer}>
      <div className={styles.messageIconArea}>
        <InfoCircleFill className={styles.messageIcon} />
      </div>
      <div className="">
        Silahkan Masukkan <b>Metode Pengantaran</b> dan <b>QTY Pengiriman</b>{" "}
        sesuai dengan barang yang akan datang ke gudang segari
      </div>
    </div>
  );
};

const InputForm = ({
  isCustom = false,
  setFieldValue,
  values,
  index,
  item,
  hasAsn,
}) => {
  return (
    <Form.Group className="mx-auto my-auto">
      <Form.Control
        min={0}
        step={"any"}
        onChange={(e) => {
          if (isCustom) {
            onChangeAsnCustomQty(e, {
              setFieldValue: setFieldValue,
              values: values,
              index: index,
            });
          } else {
            onChangeAsnQty(e, {
              setFieldValue: setFieldValue,
              values: values,
              index: index,
            });
          }
        }}
        onKeyDown={(event) => {
          if (event.key === ',') {
            event.preventDefault();
          }
        }}
        disabled={hasAsn}
        type={hasAsn ? "text" : "number"}
        className={
          (isCustom ? item.isInvalidCustom : item.isInvalid)
            ? "is-invalid"
            : "valid"
        }
        placeholder={isCustom ? `Input Order Qty` : `Input Qty`}
        value={(isCustom ? item.asnCustomQuantity : item.asnQuantity) ?? ""}
      />
      <Form.Control.Feedback type="invalid" className="text-left align-left">
        {INPUT_REQUIRED}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

const DeliveryMethod = ({
  values,
  isError,
  setFieldValue,
  isLoading,
  hasAsn,
  deliveryOptions,
}) => {
  return (
    <>
      <label className="my-2">Metode Pengantaran</label>
      <ReactSelectForm
        isClearable={true}
        name={"deliveryMethod"}
        fieldName={"deliveryMethod"}
        setFieldValue={setFieldValue}
        value={getValueFromOptions(values.deliveryMethod, deliveryOptions)}
        defaultValue={"Select"}
        placeholder={"Pilih Pengantaran"}
        options={deliveryOptions}
        isDisabled={isLoading || hasAsn}
        isMulti={false}
        customStyles={isError && customStyleError}
      />
      {isError && <div className="text-danger">{INPUT_REQUIRED}</div>}
    </>
  );
};

const EstimatedTimeArrival = ({
  values,
  setFieldValue,
  isError,
  hasAsn,
  isLoading,
}) => {
  return (
    <>
      <label className="my-2">Estimasi Waktu Pengantaran</label>
      <Col>
        <DatePicker
          style={{ width: 250 }}
          status={isError ? "error" : ""}
          allowClear
          size="large"
          value={values.expectedTimeArrival ?? null}
          placeholder="Pilih Tanggal"
          disabledDate={(current) => moment().add(-1, "days") >= current}
          format="D MMMM YYYY, HH:mm [WIB]"
          onChange={(expectedTimeArrival) =>
            setFieldValue("expectedTimeArrival", expectedTimeArrival)
          }
          showTime={{
            defaultValue: moment("00:00:00", "HH:mm:ss"),
            format: "HH:mm",
          }}
          disabled={hasAsn || isLoading}
        />
        {isError && <div className="text-danger">{INPUT_REQUIRED}</div>}
      </Col>
    </>
  );
};

export default AsnInputForm;
